export class ParseHelper {
    static parseNumber = (value: string | number): number | undefined => {
        if (!value)
            return undefined;
        if (typeof value === "number")
            return value;

        // Remove leading zeros but preserve decimal numbers
        const cleanValue = value.replace(/^0+(?=\d)/, "") || "0";
        const parsed = Number.parseFloat(cleanValue);

        return isNaN(parsed) ? 0 : parsed;
    }
    static parseBoolean = (value: string | boolean): boolean => {
        if (typeof value === "boolean")
            return value;
        return value === "true" || value === "1" || value === "on";
    }
}